export const teal = {
  1: { value: { base: '{colors.teal.light.1}', _dark: '{colors.teal.dark.1}' } },
  2: { value: { base: '{colors.teal.light.2}', _dark: '{colors.teal.dark.2}' } },
  3: { value: { base: '{colors.teal.light.3}', _dark: '{colors.teal.dark.3}' } },
  4: { value: { base: '{colors.teal.light.4}', _dark: '{colors.teal.dark.4}' } },
  5: { value: { base: '{colors.teal.light.5}', _dark: '{colors.teal.dark.5}' } },
  6: { value: { base: '{colors.teal.light.6}', _dark: '{colors.teal.dark.6}' } },
  7: { value: { base: '{colors.teal.light.7}', _dark: '{colors.teal.dark.7}' } },
  8: { value: { base: '{colors.teal.light.8}', _dark: '{colors.teal.dark.8}' } },
  9: { value: { base: '{colors.teal.light.9}', _dark: '{colors.teal.dark.9}' } },
  10: { value: { base: '{colors.teal.light.10}', _dark: '{colors.teal.dark.10}' } },
  11: { value: { base: '{colors.teal.light.11}', _dark: '{colors.teal.dark.11}' } },
  12: { value: { base: '{colors.teal.light.12}', _dark: '{colors.teal.dark.12}' } },
  a1: { value: { base: '{colors.teal.light.a1}', _dark: '{colors.teal.dark.a1}' } },
  a2: { value: { base: '{colors.teal.light.a2}', _dark: '{colors.teal.dark.a2}' } },
  a3: { value: { base: '{colors.teal.light.a3}', _dark: '{colors.teal.dark.a3}' } },
  a4: { value: { base: '{colors.teal.light.a4}', _dark: '{colors.teal.dark.a4}' } },
  a5: { value: { base: '{colors.teal.light.a5}', _dark: '{colors.teal.dark.a5}' } },
  a6: { value: { base: '{colors.teal.light.a6}', _dark: '{colors.teal.dark.a6}' } },
  a7: { value: { base: '{colors.teal.light.a7}', _dark: '{colors.teal.dark.a7}' } },
  a8: { value: { base: '{colors.teal.light.a8}', _dark: '{colors.teal.dark.a8}' } },
  a9: { value: { base: '{colors.teal.light.a9}', _dark: '{colors.teal.dark.a9}' } },
  a10: { value: { base: '{colors.teal.light.a10}', _dark: '{colors.teal.dark.a10}' } },
  a11: { value: { base: '{colors.teal.light.a11}', _dark: '{colors.teal.dark.a11}' } },
  a12: { value: { base: '{colors.teal.light.a12}', _dark: '{colors.teal.dark.a12}' } },
}
